module.exports = __webpack_public_path__ + "static/media/10.e78a09f0.jpg";